import axios from "axios";
import { BASE_URL_API } from "../Constants";

const corporateInstance = axios.create({
  baseURL: `${BASE_URL_API}/api`,
  headers: {
    "Content-Type": "application/json",
  },
});

// api call to register-corporate
async function registerCorporate(data) {
  try {
    let AUTH_TOKEN = window.localStorage.getItem("metatoken");
    var config = {
      method: "post",
      url: "/corporate/register",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + AUTH_TOKEN,
      },
      data: data,
    };

    return await corporateInstance(config)
      .then(function (response) {
        return response;
      })
      .catch(function (error) {
        return error.response;
      });
  } catch (err) {
    return err;
  }
}

// api call to update-corporate
async function updateCorporate(data) {
  try {
    let AUTH_TOKEN = window.localStorage.getItem("metatoken");
    var config = {
      method: "post",
      url: "/corporate/update",
      headers: {
        Accept: "application/json",
        "Content-Type": "multipart/form-data",
        Authorization: "Bearer " + AUTH_TOKEN,
      },
      data: data,
    };

    return await corporateInstance(config)
      .then(function (response) {
        return response;
      })
      .catch(function (error) {
        return error.response;
      });
  } catch (err) {
    return err;
  }
}

// api call to get-corporate
async function getCorporate(prams) {
  try {
    let AUTH_TOKEN = window.localStorage.getItem("metatoken");
    var config = {
      method: "get",
      url: `/corporate?identifier=${prams}`,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + AUTH_TOKEN,
      },
      data: "",
    };

    return await corporateInstance(config)
      .then(function (response) {
        return response;
      })
      .catch(function (error) {
        return error.response;
      });
  } catch (err) {
    return err;
  }
}

async function getCorporates(prams) {
  try {
    let AUTH_TOKEN = window.localStorage.getItem("metatoken") || "";
    var config = {
      method: "get",
      url: `/corporates`,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + AUTH_TOKEN,
      },
      data: "",
    };

    return await corporateInstance(config)
      .then(function (response) {
        return response;
      })
      .catch(function (error) {
        return error.response;
      });
  } catch (err) {
    return err;
  }
}

const CorporateManagement = {
  registerCorporate,
  updateCorporate,
  getCorporate,
  getCorporates
};

export default CorporateManagement;
